export const TermsAndPoliciesDataArray = [
    {
      id: 'terms-of-service',
      title: 'Terms of Service',
      group: 'agreements',
      content: [
        'These Terms of Service (Terms) govern your use of our service. By using the service, you agree to these terms.',
        'The Terms also incorporate our Data Processing Agreement and Program Policies.',
        'You are responsible for maintaining the security of your account and passwords.',
        'You may not use the service for any illegal or unauthorized purpose.',
        'We reserve the right to modify these terms at any time without prior notice.'
      ],
    },
    {
      id: 'data-processing',
      title: 'Data Processing Agreement',
      group: 'agreements',
      content: [
        'The Data Processing Agreement (DPA) outlines the handling of personal data on your behalf.',
        'You, as the data controller, maintain control over the data, while we act as the data processor.',
        'This agreement is part of our compliance with GDPR and other regulations.',
        'You are responsible for ensuring that your data processing practices comply with applicable laws.',
      ],
    },
    {
      id: 'program-policies',
      title: 'Program Policies',
      group: 'agreements',
      content: [
        'Our program policies ensure that our services are used in a manner that is safe and compliant with all applicable laws.',
        'You must not use our services for illegal activities or purposes.',
        'Failure to comply with these policies may result in suspension or termination of your account.',
      ],
    },
    {
      id: 'sla',
      title: 'SLA',
      group: 'agreements',
      content: [
        'The Service Level Agreement (SLA) defines the level of service you can expect from us.',
        'We commit to a certain level of uptime and availability for our services.',
        'In the event of service disruptions, we will work diligently to restore service as quickly as possible.',
      ],
    },
    {
      id: 'business-associate-agreement',
      title: 'Business Associate Agreement',
      group: 'agreements',
      content: [
        'This Business Associate Agreement (BAA) is required under HIPAA regulations.',
        'It governs the relationship between us and any covered entities with respect to protected health information (PHI).',
        'We agree to comply with all applicable HIPAA regulations in our handling of PHI.',
      ],
    },
    {
      id: 'mutual-nda',
      title: 'Mutual Non-Disclosure Agreement',
      group: 'agreements',
      content: [
        'The Mutual Non-Disclosure Agreement (NDA) ensures that both parties keep confidential information secure.',
        'Both parties agree not to disclose any confidential information to third parties without consent.',
        'The NDA is effective as of the date signed by both parties and remains in effect for the duration specified in the agreement.',
      ],
    },
    {
      id: 'privacy-policy',
      title: 'Privacy Policy',
      group: 'policies',
      content: [
        'Our Privacy Policy explains how we collect, use, and protect your personal information.',
        'We are committed to protecting your privacy and ensuring that your personal information is handled securely.',
        'This policy applies to all data collected through our website and services.',
      ],
    },
    {
      id: 'cookies-policy',
      title: 'Cookies Policy',
      group: 'policies',
      content: [
        'Our Cookies Policy explains how we use cookies and similar technologies to enhance your experience on our website.',
        'By using our website, you consent to the use of cookies in accordance with this policy.',
        'You can manage your cookie preferences through your browser settings.',
      ],
    },
    {
      id: 'security-policy',
      title: 'Security Policy',
      group: 'policies',
      content: [
        'Our Security Policy outlines the measures we take to protect your data and ensure the security of our services.',
        'We implement industry-standard security practices to protect against unauthorized access and data breaches.',
        'Regular security audits and updates are conducted to maintain the integrity of our systems.',
      ],
    },
    {
      id: 'gdpr',
      title: 'General Data Protection Regulation (GDPR)',
      group: 'compliance',
      content: [
        'The GDPR is a regulation in EU law on data protection and privacy for all individuals within the European Union.',
        'We are committed to ensuring our compliance with GDPR and protecting the personal data of our EU customers.',
        'This section outlines your rights under GDPR and how we manage and protect your data.',
      ],
    },
    {
      id: 'imprint',
      title: 'Imprint',
      group: 'other',
      content: [
        'Our imprint provides legal information about our company, including our registered address and contact details.',
        'This section is required by law in certain jurisdictions to ensure transparency and accountability.',
        'You can contact us through the provided information for any legal or compliance-related inquiries.',
      ],
    },
  ];
  